export default __webpack_public_path__ + "static/media/filter_icon_reception.7ef6d1ed.svg";